/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Fmt_SubInputs */

const en_vc_fmt_sub = /** @type {(inputs: Vc_Fmt_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft saves to a documented JSON format and reads and writes the common exchange formats, including Affinity documents that Illustrator can't open.`)
};

const zh_vc_fmt_sub = /** @type {(inputs: Vc_Fmt_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 以公开文档的 JSON 格式保存，并支持常见交换格式的读写，甚至能打开 Illustrator 打不开的 Affinity 文件。`)
};

/**
* | output |
* | --- |
* | "VectorCraft saves to a documented JSON format and reads and writes the common exchange formats, including Affinity documents that Illustrator can't open." |
*
* @param {Vc_Fmt_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_fmt_sub = /** @type {((inputs?: Vc_Fmt_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Fmt_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_fmt_sub(inputs)
	return zh_vc_fmt_sub(inputs)
});
export { vc_fmt_sub as "vc.fmt.sub" }